import { Koi } from '@ksyos/koi';

export const osasMijnKsyosQuestionnaireSchema = Koi.object({
    processQuestionnaireResponseId: Koi.string().optional(),
});
